<div class="service-container">
    <div class="service-page-wrap">
        <a href="" class="logo-img"><img src="assets/img/mrs-logo.png" alt="MRS Logo"></a>
        <div class="hero-img">
            <img src="assets/img/service-page-hero.svg" alt="Service Down">
        </div>
        <p [innerHTML]="'service_downtime.long_description' | translate"></p>
    </div>
</div>
